export default __webpack_public_path__ + "static/media/step-6@3x.b0371d7a.png";